<template>
  <el-button class="btn-add" icon="el-icon-plus" @click="goToAddPage">{{value}}</el-button>
</template>

<script>
import { nAlert } from "../../utils/notice";

export default {
  name: "button-add",
  props: {
    value: {
      type: String,
      default: "添加"
    },
    pathName: {
      type: String
    }
  },
  methods: {
    goToAddPage() {
      // if (this.pathName === 'housing-add') {
      //   let yqCode = window.sessionStorage.getItem('buildingyqCode')
      //   let buildingLevel = window.sessionStorage.getItem('buildingLevel')
      //   if ((!yqCode) || (buildingLevel !== '3')) {
      //     nAlert('请先选择房源所属楼层')
      //     return false
      //   }
      // }
      if (this.pathName === "housing-building-add") {
        window.sessionStorage.setItem(
          "housingManagementPageHousingTabState",
          "housing_building"
        );
      }
      this.$router.push({
        name: this.pathName
      });
    }
  }
};
</script>

<style scoped>
.btn-add {
  border: 0;
  color: #fff;
  padding: 5px 16px;
  background-color: #1362ff;
  font-size: 13px;
  height: 32px;
}
.btn-add:hover {
  color: #fff;
  background-color: #06b3ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Button/ButtonAdd.vue